import React from 'react';
import { Translate } from 'react-jhipster';
import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const GRADIENT = 'linear-gradient(90.72deg, #2476f0 0.32%, #00207c 103.75%)';

export interface INotificationsAllDialogProps {
  open: boolean;
  onClose: () => void;
  allNotifications: any[];
  totalUnread: number;
  onDismissAll: () => void;
  onOpenOrder: (orderId: string, statusType: string, entity: any) => void;
}

const NotificationsAllDialog = (props: INotificationsAllDialogProps) => {
  const { open, onClose, allNotifications, totalUnread, onDismissAll, onOpenOrder } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { background: GRADIENT, borderRadius: 2, maxHeight: '80vh' },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        <Typography fontWeight={700} fontSize={17} sx={{ color: '#fff' }}>
          <Translate contentKey="global.menu.notifications" /> ({totalUnread})
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Button
            size="small"
            sx={{
              textTransform: 'none',
              color: 'rgba(255,255,255,0.85)',
              fontSize: 13,
              '&:hover': { color: '#fff', background: 'transparent' },
            }}
            onClick={onDismissAll}
          >
            <Translate contentKey="global.rightMenuNotification.markAll" />
          </Button>
          <IconButton size="small" onClick={onClose} sx={{ color: 'rgba(255,255,255,0.7)' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ px: 2, pb: 2, pt: 0 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {allNotifications.length === 0 ? (
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <Typography sx={{ color: 'rgba(255,255,255,0.6)' }}>No notifications</Typography>
            </Box>
          ) : (
            allNotifications.map(entity => {
              const quotationRef = entity?.notificationTemplate?.message?.includes('quotation no.')
                ? entity?.quotationId
                : entity?.bursaAPIBidCert?.ecertNo;

              const isRead = entity.dismissed;

              return (
                <Box
                  key={entity.id}
                  sx={{
                    px: 2,
                    py: 1.5,
                    borderRadius: 1.5,
                    background: isRead ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.14)',
                    border: isRead ? 'none' : '1px solid rgba(255,255,255,0.2)',
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography fontWeight={isRead ? 400 : 700} fontSize={14} lineHeight={1.4} sx={{ color: '#fff' }}>
                        <Translate
                          contentKey={`global.rightMenuNotification.${entity.notificationTemplate.type}`}
                          interpolate={{ id: quotationRef }}
                        />
                      </Typography>
                      <Typography fontSize={12} sx={{ color: 'rgba(255,255,255,0.6)', mt: 0.4 }}>
                        {moment.utc(entity.createdDate).local().calendar()}
                      </Typography>
                    </Box>
                    <Typography fontSize={11} sx={{ color: 'rgba(255,255,255,0.5)', whiteSpace: 'nowrap', pt: 0.3 }}>
                      {moment.utc(entity.createdDate).local().fromNow()}
                    </Typography>
                  </Box>

                  {entity.quotationId && (
                    <Box sx={{ mt: 1 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        sx={{
                          textTransform: 'none',
                          color: '#fff',
                          borderColor: 'rgba(255,255,255,0.4)',
                          fontSize: 12,
                          py: 0.25,
                          '&:hover': { borderColor: '#fff', background: 'rgba(255,255,255,0.1)' },
                        }}
                        onClick={() => onOpenOrder(entity.quotationId, entity.notificationTemplate.type, entity)}
                      >
                        <Translate contentKey="global.rightMenuNotification.openOrder" />
                      </Button>
                    </Box>
                  )}
                </Box>
              );
            })
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationsAllDialog;
